/**
 * The 44px column at the end of a scan row.
 *
 * Was three unlabelled icon buttons, each of which had to call
 * `stopPropagation` because the `<tr>` around them had its own click. The row's
 * own control is a real button now, so nothing here fights it.
 *
 * The entries themselves live in `ScanRowItems`, because the row's right-click
 * menu offers the same ones and two lists would drift apart.
 */
import { MoreHorizontal } from "lucide-react";
import { cn } from "@wa/ui";
import type { ScanListItem } from "../../../../lib/siteScan";
import { Pop, useClosePops } from "../../../shell/Pop";
import type { T } from "../types";
import { ScanRowItems } from "./ScanRowItems";

export function ScanRowMenu({
  row,
  canManage,
  t,
  onOpen,
  onRescan,
  onDelete,
}: {
  row: ScanListItem;
  canManage: boolean;
  t: T;
  onOpen: () => void;
  onRescan: () => void;
  onDelete: () => void;
}) {
  const close = useClosePops();

  return (
    // Above the row-covering overlay, or the menu would never get the click.
    <span className="relative z-[1] justify-self-end">
      <Pop
        trigger={(open) => (
          <button
            type="button"
            className={cn("crm-cb", open && "is-on")}
            title={t("common.more")}
            aria-label={t("common.more")}
            aria-haspopup="menu"
            aria-expanded={open}
          >
            <MoreHorizontal className="size-4" />
          </button>
        )}
      >
        <ScanRowItems
          row={row}
          canManage={canManage}
          t={t}
          close={close}
          onOpen={onOpen}
          onRescan={onRescan}
          onDelete={onDelete}
        />
      </Pop>
    </span>
  );
}
